// http://dougtesting.net/winwheel/docs

const { 
  useState,
  useEffect,
  useRef
} = wp.element
import { 
  useSelector, 
  useDispatch 
} from 'react-redux'
import { 
  uiMessage
} from 'data/redux/actions'
import AvatarEditor from 'react-avatar-editor'
import { api } from 'commonutils/api'
import 'commonutils/TweenMax.min'
import Winwheel from 'commonutils/Winwheel'
import tick from 'assets/audio/tick.mp3'
import ohno from 'assets/audio/ohno.mp3'
import ohyeah from 'assets/audio/ohyeah.mp3'

export const Roulette = props => {

  const sounds = {
    tick: new Audio(tick),
    ohno: new Audio(ohno),
    ohyeah: props.sounds['ohyeah'] || new Audio(ohyeah) 
  }

  const dispatch = useDispatch()
  const useravatar = useSelector(state => state.user.avatar)
  const canvasRef = useRef()  

  let wheelPower  = 0;
  let wheelSpinning = false;
  let acumulado = 0;

  const [ theweel, setTheweel ] = useState() 
  const [ premio, setPremio ] = useState()

  const play = sound => {

    sounds[sound].pause();
    sounds[sound].currentTime = 0;
    sounds[sound].play();
  }

  const alertPrize = indicatedSegment => {

    setPremio(indicatedSegment.text)
    
    play('ohyeah')
  }
    
  const spin = () => {

    setPremio(null)
    theweel.stopAnimation(false);
    theweel.rotationAngle = 0;
    theweel.draw();
    wheelSpinning = false;
    wheelPower = 3;
    theweel.animation.spins = 10;    
    theweel.startAnimation();
    wheelSpinning = true;
  }

  useEffect(() => {

    let w = new Winwheel({
      canvas: canvasRef.current,
      outerRadius: 127,
      innerRadius: 0,
      drawMode : 'image',
      drawText: true,
      numSegments: 5,
      segments: props.segments || [],      
      textOrientation: 'curved',
      textAlignment: 'outer',
      textMargin: 15,
      textFontFamily: props.font || 'Arial',
      textFontSize: 12,
      textFillStyle: 'black',
      strokeStyle: 'white',
      lineWidth: 3,
      animation: {
        type: 'spinToStop',
        duration: 10,
        spins: 3,
        callbackFinished: alertPrize,
        callbackSound: () => play('tick'),
        soundTrigger: 'pin'
      },
      pins: {
        number: props.segments.length,
        fillStyle: 'transparent',
        outerRadius: 0,
      }
    })  

    let wheelImg = new Image(); 
    wheelImg.onload = () => {

      w.wheelImage = wheelImg;
      w.draw();

      setTheweel(w)
    }
    wheelImg.src = props.imgroulette
    w.draw(true)

  }, [])

  return <div className="roulette">
    <div className="wrapper">
      <div className="award">
        {
          premio && <>
            <span className="text">Has ganado</span>
            <span className="premio">{ premio }</span>
          </>
        }
      </div>
      <div className="rotor">
        <div class="wheel">
          <div className="frame" />
          <div className="canvas">
            <canvas 
              ref={ canvasRef }
              width="254" 
              height="254"
            ></canvas>
          </div>
          <div className="pointer" />
        </div>
        <div class="controls">
          <button onClick={ spin }>Girar la ruleta</button>
        </div>
      </div>
    </div>
  </div>
}